import { erpAxios } from '..';

const fetchKomitentById = async (id) => {
  const { data } = await erpAxios.get(`/komitenti/getById/${id}`);

  return data ? data : null;
};

export default fetchKomitentById;
